<template>
  <TipMatchSelectRole
    :is-modify="true"
    :role-list="roleList"
    :show-empty="false"
    :can-close="true"
    :select-no="selectNo"
    :show="show"
    @dissmissDialog="$emit('dissmissDialog')"
    @onClickSelect="(idx)=>$emit('onClickSelect', idx)"
    @onClickBindAccount="onClickBindAccount"
  />
</template>

<script>
import TipMatchSelectRole from 'src/local-component/ui/tip-match/tip-match-select-role-popup/index';

export default {
  components: {
    TipMatchSelectRole,
  },
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    selectedNRoleIdx: {
      type: String,
      default: '',
    },
    roleList: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {

    };
  },
  computed: {
    selectNo() {
      return this.roleList.findIndex(item => item.roleidx === this.selectedNRoleIdx);
    },
  },
  mounted() {

  },
  methods: {
    onClickBindAccount() {
      uni.redirectTo({ url: '/views/home/homepage/account-manage' });
    },
  },
};
</script>
